import React from 'react';
import { Box, Typography } from '@mui/material';
import { buildBackendAisleName } from 'core/slices/utils/aisleNames';
import { CardRow, StatusBadge, titleSx } from '../taskUtils';

export default function MissingLandmark({ task, t, completed }) {
  const { landmark, aisle, orientation, aisle_part, client_aisle_name, status } =
    task;
  const aisleDisplay =
    client_aisle_name ||
    buildBackendAisleName(aisle, orientation, aisle_part) ||
    '-';

  return (
    <Box sx={{ minWidth: 0, width: "100%" }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'nowrap' }}>
        <Typography variant="subtitle2" fontWeight={700} sx={{ ...titleSx, flexShrink: 1, minWidth: 0 }}>
          {landmark || '—'}
        </Typography>
        {completed && <StatusBadge status={status} label={t(`bruno.task_status.${status}`, status)} />}
      </Box>
      <CardRow label={t('bruno.tasks_details.aisle', 'Aisle')} value={aisleDisplay} />
    </Box>
  );
}
